// extracted by mini-css-extract-plugin
export default {"formContent":"Forms_formContent__Qj+Jw","tableRow":"Forms_tableRow__UFqJk"};